import _ from 'lodash';
import { createSelector } from 'reselect';
import { TREND_SEARCH_PAGE_SIZE } from '../../../../utils/constants';
import * as fromState from '../../../reducers';

export const getTrendPage = createSelector(
  [fromState.getTrendIds],
  trendIds => Math.ceil(_.size(trendIds) / TREND_SEARCH_PAGE_SIZE) - 1
);